export const ComparatorTooltipText = () => (
  <ul className="ml-3 list-disc">
    <li>IS: The condition is met if ANY instances of the field match the value</li>
    <li>IS NOT: The condition is met if NONE instances of the field match the value</li>
    <li>IS EMPTY: The condition is met if ALL instances of the field are empty</li>
    <li>IS NOT EMPTY: The condition is met if ANY instances of the field are not empty</li>
  </ul>
);
